import LoginForm from './components/LoginForm';
import useLogin from './useLogin';

const Login = () => {
  const {
    phoneNumber,
    password,
    isLoginBtnDisabled,
    isSaveIdChecked,
    onChangePhoneNumber,
    onChangePassword,
    onSubmit,
    onClickJoinBtn,
    handleSaveIdChange,
  } = useLogin();

  return (
    <div className="wrap wrap_temporary logn">
      <div className="container login_container">
        <h2 className="fw-b">로그인</h2>
        <LoginForm
          phoneNumber={phoneNumber}
          password={password}
          onChangePhoneNumber={onChangePhoneNumber}
          onChangePassword={onChangePassword}
          onSubmit={onSubmit}
          disabled={isLoginBtnDisabled}
          isSaveIdChecked={isSaveIdChecked}
          handleSaveIdChange={handleSaveIdChange}
        />
        <div className="buttons-logn">
          <a className="body-n-n fw-b pointer_cursor" onClick={onClickJoinBtn}>
            회원가입
          </a>
          <a className="body-n-n fw-b" />
        </div>
      </div>
    </div>
  );
};

export default Login;
